export const editActivityFlexGap = '16px';
